import { FC, ReactNode } from 'react';
import { Root } from './styled';

type Props = {
  children?: ReactNode;
};

const Accordion: FC<Props> = ({ children }) => {
  return <Root>{children}</Root>;
};

export default Accordion;
